import { User } from "@prisma/client";
import { createContext, useContext, useState } from "react";
import { ReactNode } from "react";
import { authenticator } from "~/services/auth/auth.server";

type UserContextType = {
  user: User | null;
  updateUser: (user: User) => void;
};

const initialUserContext: UserContextType = {
  user: null,
  updateUser: () => {}
};

const UserContext = createContext<UserContextType>(initialUserContext);

export function useUser() {
  return useContext(UserContext);
}

export async function useUserGuard(request: Request) {
  const user = await authenticator.isAuthenticated(request, { failureRedirect: "/login" });
  return user;
}

interface UserProviderProps {
  children: ReactNode;
  initialUser?: User | null;
}

export function UserProvider({ children, initialUser = null }: UserProviderProps) {
  const [user, setUser] = useState<User | null>(initialUser);

  const updateUser = (newUser: User) => {
    setUser(newUser);
  };

  const value = {
    user,
    updateUser
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export function useUpdateUser() {
  const { updateUser } = useContext(UserContext);
  return updateUser;
}